import { getQueryStringParameter } from 'owa-querystring';
import { getLogicalRing } from 'owa-config';

// This util checks for non-prod user.
// If forceUX query param matches input name, it bypasses checks and loads the feature

const canBypassFeatureCheck = (name: string): boolean => {
    const feature = getQueryStringParameter('forceUX');
    const isNonProdUser = getLogicalRing() === 'Dogfood' || getLogicalRing() === 'Microsoft';
    return isNonProdUser && feature === name;
};

export default canBypassFeatureCheck;
